import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: {
            language: "Please select your language",
            form_types: {
                client: "Client",
                visitor: "Visitor",
                press: "Press",
                supplier: "Supplier",
                broker: "Broker"
            },
            size: "Size",
            tour_giver: "Who gives the tour",
            broker_select: "Broker",
            new_broker: "+ New broker",
            broker_first_name: "Broker first name",
            broker_last_name: "Broker surname",
            broker_email: "Broker email",
            broker_company: "Broker company",
            broker_country: "Broker country",
            broker_comment: "Comment on the broker",
            lead_name: "Lead name",
            broker_required: "Please select or create a broker",
            relogin:"Refresh the page and login again",
            title: 'Signup for your Dealer',
            title_broker: 'Signup for your Broker',
            with_signature: "With signature",
            hear_from_you: "We'd love to hear from you",
            form_type:"I am a... ",
            zip: "ZIP",
            email: "Email",
            phone_number: "Phone number (with country code, e.g. +49)",
            phone_invalid: "Please enter a valid phone number",
            phone_not_mobile: "This looks like a landline — you won't receive SMS updates",
            first_name: "First Name",
            last_name: "Last Name",
            country: "Country",
            navigation_area: "Navigation Area",
            dealer: "Dealer",
            sales_person: "Sales Person",
            address: "Address",
            city: "City",
            comment: "Comment",
            boat_model: "Boat Model",
            drive_type: "Drive Type",
            distributor_policy: "I agree that my data will be stored and shared with the appropriate distributor based on my navigation area or residence country so that they can contact me for sales and marketing",
            privacy_policy: "I accept your Privacy Policy",
            sign: "Please sign here for GDPR purposes",
            or_sign: "Please sign here if you haven't",
            submit: "Submit",
            thanks: "The form has been submitted. Thank you."
        }
    },
    de: {
        translation: {
            language: "Bitte wählen Sie Ihre Sprache",
            form_types: {
                client: "Kunden",
                visitor: "Gast",
                press: "Presse",
                supplier: "Lieferant",
                broker: "Broker"
            },
            size: "Größe",
            tour_giver: "Wer führt die Tour durch",
            broker_select: "Broker",
            new_broker: "+ Neuer Broker",
            broker_first_name: "Broker Vorname",
            broker_last_name: "Broker Nachname",
            broker_email: "Broker E-Mail",
            broker_company: "Broker Firma",
            broker_country: "Broker Land",
            broker_comment: "Kommentar zum Broker",
            lead_name: "Name des Leads",
            broker_required: "Bitte wählen oder erstellen Sie einen Broker",
            relogin:"Refresh the page and login again",
            zip:"PLZ",
            title: 'Melden Sie sich für Ihren Händler an',
            title_broker: 'Melden Sie sich für Ihren Broker an',
            with_signature: "Mit Unterschrift",
            hear_from_you: "Wir würden uns freuen, von Ihnen zu hören",
            form_type: "Ich bin ein... ",
            email: "Email",
            phone_number: "Telefonnummer (mit Ländervorwahl, z. B. +49)",
            phone_invalid: "Bitte geben Sie eine gültige Telefonnummer ein",
            phone_not_mobile: "Dies scheint ein Festnetzanschluss zu sein – Sie erhalten keine SMS-Updates",
            first_name: "Vorname",
            last_name: "Nachname",
            country: "Land",
            navigation_area: "Navigationsbereich",
            dealer: "Händler",
            sales_person: "Verkäufer",
            address: "Adresse",
            city: "Stadt",
            comment: "Kommentar",
            boat_model: "Bootsmodell",
            drive_type: "Antriebsart",
            distributor_policy: "Ich stimme zu, dass meine Daten an den Vertragshändler von greenline in der Nähe meines Wohn- oder Navigationslandes weitergegeben werden",
            privacy_policy: "Akzeptieren Sie unsere Datenschutzrichtlinie",
            sign: "Bitte unterschreiben Sie hier für DSGVO-Zwecke",
            or_sign: "Bitte unterschreiben Sie hier, falls noch nicht geschehen",
            submit: "Einsenden",
            thanks: "Das Formular wurde übermittelt. Vielen Dank."
        }
    },
    sl: {
        translation: {
            language: "Prosimo, izberite svoj jezik",
            form_types: {
                client: "Stranka",
                visitor: "Obiskovalec",
                press: "Pritisnite",
                supplier: "dobavitelj",
                broker: "Posrednik"
            },
            size: "Velikost",
            tour_giver: "Kdo vodi ogled",
            broker_select: "Posrednik",
            new_broker: "+ Nov posrednik",
            broker_first_name: "Ime posrednika",
            broker_last_name: "Priimek posrednika",
            broker_email: "E-pošta posrednika",
            broker_company: "Podjetje posrednika",
            broker_country: "Država posrednika",
            broker_comment: "Komentar o posredniku",
            lead_name: "Ime stranke",
            broker_required: "Izberite ali ustvarite posrednika",
            relogin:"Refresh the page and login again",
            zip: 'Zip',
            title: 'Prijavite se za svojega trgovca',
            title_broker: 'Prijavite se za svojega posrednika',
            with_signature: "S podpisom",
            hear_from_you: "Radi bi slišali od vas",
            form_type:"Jaz sem... ",
            email: "E-naslov",
            phone_number: "Telefonska številka (s klicno kodo države, npr. +386)",
            phone_invalid: "Vnesite veljavno telefonsko številko",
            phone_not_mobile: "Ta številka je verjetno stacionarna – SMS obvestil ne boste prejemali",
            first_name: "Ime",
            last_name: "Priimek",
            country: "Država",
            navigation_area: "Navigacijsko območje",
            dealer: "Prodajalec",
            sales_person: "Prodajalec",
            address: "naslov",
            city: "mesto",
            comment: "Komentar",
            boat_model: "Model čolna",
            drive_type: "Vrsta pogona",
            distributor_policy: "Strinjam se, da bodo moji podatki posredovani pogodbenemu distributerju Greenline v bližini moje države bivanja ali države plovbe",
            privacy_policy: "Sprejmite našo politiko zasebnosti",
            sign: "Prosimo, podpišite se tukaj za namene GDPR",
            or_sign: "Prosimo, podpišite se tukaj, če še niste",
            submit: "Pošlji",
            thanks: "Obrazec je oddan. Hvala vam."
        }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;